import type { FallbackProps } from "react-error-boundary";

export function GlobalErrorFallback({ error, resetErrorBoundary }: FallbackProps) {
  return (
    <div role="alert" className="min-h-screen grid place-items-center p-8">
      <div className="max-w-md text-center">
        <h1 className="text-xl font-medium mb-2">Something broke.</h1>
        <p className="text-sm text-zinc-500 mb-4">{error.message}</p>
        <button
          className="rounded-xl bg-slate-900 px-4 py-2 text-sm font-medium text-white hover:bg-slate-800"
          onClick={resetErrorBoundary}
        >
          Reload
        </button>
      </div>
    </div>
  );
}
